import React from 'react';
import Icon from './Question.svg';

export default (props) => <Icon {...props} />;
